/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Modal, Form, Header } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import FileSaver from 'file-saver';
//import { v4 as uuidv4 } from 'uuid';
import WithRouter from '../Extensions/WithRouter';
//import cx from 'classnames';
//import $ from 'jquery';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import Loader from '../Loader/Loader';
import {
  SPDX_EXTENSION_JSON,
  //REPORT_EXTENSION_EXCEL
} from '../../constants/reports';
import './NISModal.css';

class NISModal extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.modalHeader = null;
    this.modalSubBody = null;
    this.state = {
      isLoading: false,
      isDownloadLoading: false,
      isOpenWarnModal: false,
      isOpenAlertModal: false,
      isSaveSbom: false,
      isExportDoc: false,
      isTypeError: false,
      isProductNameError: false,
      sbomType: 'design',
      precisionLevel: '',
      productName: '',
      productVersion: '',
      sbomAuthorName: '',
      sbomStandard: '',
      exportFormat: 'json',
      toExport: 'local',
    };
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handlePrecisionLevelChange = this.handlePrecisionLevelChange.bind(this);
    this.handleExportFormatChange = this.handleExportFormatChange.bind(this);
    this.handleProductNameChange = this.handleProductNameChange.bind(this);
    this.handleProductVersionChange = this.handleProductVersionChange.bind(this);
    this.handleExportPathChange = this.handleExportPathChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setNISInfo = this.setNISInfo.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
    this.closeWarnModal = this.closeWarnModal.bind(this);
    this.closeNISModal = this.closeNISModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMNA } = this.props;
    if (prevProps.isOpenMNA !== isOpenMNA) {
      this.setState({
        isLoading: false,
        isDownloadLoading: false,
        isOpenWarnModal: false,
        isOpenAlertModal: false,
        isSaveSbom: false,
        isExportDoc: false,
        isTypeError: false,
        isProductNameError: false,
        sbomType: 'design',
        precisionLevel: '',
        productName: '',
        productVersion: '',
        sbomAuthorName: '',
        sbomStandard: '',
        exportFormat: 'json',
        toExport: 'local',
      }, () => {
        if (isOpenMNA) {
          this.getNISInfo();
        }
      });
    }
  }

  handleTypeChange = (e, { value }) => {
    this.setState({
      sbomType: value,
      isTypeError: false,
    });
  };

  handlePrecisionLevelChange = (e) => {
    this.setState({
      precisionLevel: e.target.value,
    });
  };

  handleExportFormatChange = (e, { value }) => {
    this.setState({
      exportFormat: value,
    });
  };

  handleProductNameChange = (e) => {
    this.setState({
      productName: e.target.value,
      isProductNameError: false,
    });
  };

  handleProductVersionChange = (e) => {
    this.setState({
      productVersion: e.target.value,
    });
  };

  handleNameChange = (e) => {
    this.setState({
      sbomAuthorName: e.target.value,
    });
  };

  handleExportPathChange = (e, { value }) => {
    this.setState({
      toExport: value,
    });
  };

  onSubmit() {
    const { translate } = this.props;

    if (!this.isValidation()) {
      return;
    }

    this.modalAction = translate('modal.title.attention');
    this.modalBody = translate('modal.message.create_document');

    this.setState({
      isSaveSbom: true,
      isOpenWarnModal: true,
    });
  }

  getNISInfo() {
    const { reportId } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getNISInfo(reportId)
        .then((res) => {
          const data = convertPropertiesToCamelCase(res.response);
          this.setState({
            isLoading: false,
            precisionLevel: data.precisionLevel,
            productName: data.productName,
            sbomAuthorName: data.sbomAuthorName,
            sbomStandard: data.sbomStandard,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoading: false,
          });
        });
    });
  }

  setPrecisionLevel(precision) {
    const { state } = this.props;
    const { currentPrecisionLevel } = state.user;

    let data;
    if (currentPrecisionLevel !== null && currentPrecisionLevel !== '') {
      data = currentPrecisionLevel;
    } else {
      data = precision || 'N/A';
    }

    return data;
  }

  setNISInfo() {
    const {
      sbomType,
      productName,
      productVersion,
      sbomAuthorName,
      precisionLevel,
      exportFormat,
      toExport,
    } = this.state;
    const { reportId, translate } = this.props;

    let precision;

    if (this.setPrecisionLevel(precisionLevel) === 'N/A') {
      precision = '';
    } else {
      precision = this.setPrecisionLevel(precisionLevel);
    }

    const isJsonBlob = (data) => {
      return data instanceof Blob && data.type === 'application/json';
    };

    const obj = {
      sbom_type: sbomType,
      product_name: productName,
      product_version: productVersion,
      sbom_author_name: sbomAuthorName,
      precision_level: precision,
      export_format: exportFormat,
      export_to: toExport
    };

    this.setState({
      isOpenWarnModal: false,
      isDownloadLoading: true,
    }, () => {
      api
        .setNISInfo(obj, reportId)
        .then(async (res) => {
          let data;
          let file_name;

          if (exportFormat === SPDX_EXTENSION_JSON) {
            data = new Blob([res], { type: 'application/json' });
            file_name = `sbom.nis.${productName}.json`;
          } else {
            data = new Blob([res], { type: 'application/octet-stream' });
            file_name = `sbom.nis.${productName}.xlsx`;
          }

          this.modalAction = translate('modal.title.notice');

          if (toExport === 's3') {
            data = JSON.parse(new TextDecoder().decode(res));
            const { bucket, key } = data.response;
            this.modalBody = translate('modal.message.export_send_s3');
            this.modalHeader = (
              <p className="modal_list" style={{ paddingTop: '10px' }}>
                <b>{translate('modal.title.bucket')}</b>
                &nbsp;
                {bucket}
              </p>
            );
            this.modalSubBody = (
              <p className="modal_list">
                <b>{translate('modal.title.file_storage_path')}</b>
                &nbsp;
                {key}
              </p>
            );
          } else if (toExport === 'email') {
            data = JSON.parse(new TextDecoder().decode(res));
            const { dest_email } = data.response;
            this.modalBody = translate('modal.message.export_send_email');
            this.modalHeader = translate('modal.message.export_send_to_email', { email: dest_email });
            this.modalSubBody = null;
          } else if (toExport === 'local') {
            FileSaver.saveAs(data, file_name);
            this.modalBody = translate('modal.message.export_send_local');
            this.modalHeader = null;
            this.modalSubBody = null;
          }

          this.setState({
            isDownloadLoading: false,
            isExportDoc: true,
            isOpenAlertModal: true,
          });
        })
        .catch(async (err) => {
          console.log(err);
          const responseData = isJsonBlob(err.data) ? await (err.data)?.text() : err.data || {};
          const responseJson = (typeof responseData === 'string') ? JSON.parse(responseData) : responseData;

          const o = responseJson.response;

          this.modalAction = translate('modal.title.attention');

          if (!o.error) {
            this.modalBody = translate('modal.error.unknow_error');
          }

          if (o.error === '422-602') { //precision_level error
            this.modalBody = translate('modal.error.error_422_091_param');
          }

          if (o.error === '422-236') { //export format error
            this.modalBody = translate('modal.error.error_422_211_value');
          }

          if (o.error === '422-091') { //request body error
            this.modalBody = translate('modal.error.error_422_091_param');
          }

          this.setState({
            isDownloadLoading: false,
            isExportDoc: false,
            isOpenAlertModal: true,
          });
        });
    });
  }

  isValidation() {
    const { translate } = this.props;
    const {
      sbomType,
      productName,
    } = this.state;

    if (sbomType === '') {
      this.modalAction = translate('modal.title.attention');
      this.modalBody = translate('modal.message.nis_sbom_type_required');

      this.setState({
        isOpenAlertModal: true,
        isExportDoc: false,
        isTypeError: true,
      });
      return false;
    }

    if (productName === '') {
      this.modalAction = translate('modal.title.attention');
      this.modalBody = translate('modal.message.nis_product_name_required');

      this.setState({
        isOpenAlertModal: true,
        isExportDoc: false,
        isProductNameError: true,
      });
      return false;
    }
    return true;
  }

  closeModal(e) {
    const { translate } = this.props;
    if (e.target.classList[0] === 'right_button') {
      return null;
    }

    this.modalAction = translate('modal.title.attention');
    this.modalBody = translate('modal.message.create_document_cancel');
    this.setState({
      isSaveSbom: false,
      isOpenWarnModal: true,
    });
  }

  closeAlertModal() {
    this.setState({
      isOpenAlertModal: false,
      isExportDoc: false,
    });
  }

  closeNISModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  closeWarnModal() {
    this.setState({
      isSaveSbom: false,
      isOpenWarnModal: false,
    });
  }

  render() {
    const {
      translate,
      isOpenMNA
    } = this.props;
    const {
      isOpenAlertModal,
      isOpenWarnModal,
      isDownloadLoading,
      isLoading,
      isSaveSbom,
      sbomType,
      precisionLevel,
      exportFormat,
      productName,
      productVersion,
      sbomAuthorName,
      sbomStandard,
      toExport,
      isExportDoc,
      isTypeError,
      isProductNameError,
    } = this.state;

    const exportPathOptions = [
      { key: 'local', text: 'Local File System', value: 'local' }
      /*{ key: 's3', text: 'S3', value: 's3' },
      { key: 'email', text: 'Email', value: 'email' }*/
    ];

    const exportFormatOptions = [
      { key: SPDX_EXTENSION_JSON, text: 'JSON', value: SPDX_EXTENSION_JSON },
      //{ key: REPORT_EXTENSION_EXCEL, text: 'Excel', value: REPORT_EXTENSION_EXCEL },
    ];

    const sbomTypeOptions = [
      { key: 'design', text: translate('modal.content.design'), value: 'design' },
      { key: 'source', text: translate('modal.content.source'), value: 'source' },
      { key: 'build', text: translate('modal.content.build'), value: 'build' },
      { key: 'analyzed', text: translate('modal.content.analyzed'), value: 'analyzed' },
      { key: 'deployed', text: translate('modal.content.deployed'), value: 'deployed' },
      { key: 'runtime', text: translate('modal.content.runtime'), value: 'runtime' },
    ];

    const getModalContent = () => {
      if (isDownloadLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup nis">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '35%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.prepare_nis_download')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      if (isLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup nis">
              <div style={{ verticalAlign: 'middle', textAlign: 'center', marginTop: '20%' }}>
                <Loader
                  style={{
                    position: 'relative',
                    width: '80%',
                    height: '80%',
                    marginBottom: '15%',
                  }}
                />
                <span
                  style={{
                    fontWeight: '500',
                    fontSize: '16px',
                    marginTop: '35%',
                    display: 'inline-block',
                  }}
                >
                  {translate('modal.message.loading')}
                </span>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div>
          <div className="setting_popup_wrap">
            <div
              className="setting_popup nis"
            >
              <div className="setting_popup_header">
                <span className="popup_name">
                  <h2>{translate('modal.title.create_nis_document')}</h2>
                  <h4 style={{ paddingLeft: '5px' }}>
                    {translate('modal.title.nis_sbom_ver')}
                    {' '}
                    { sbomStandard }
                  </h4>
                </span>
                <a
                  className="popup_close_button"
                  style={{ top: '30px', right: '30px' }}
                  onClick={this.closeModal}
                >
                  <img src={closeBtn} alt="" />
                </a>
              </div>
              <Scrollbars
                style={{
                  height: '690px',
                  overflow: 'hidden',
                  position: 'relative',
                }}
                renderTrackHorizontal={() => {
                  return <div />;
                }}
                renderThumbHorizontal={() => {
                  return <div />;
                }}
              >
                <Form>
                  <Form.Group widths="equal">
                    <Form.Field required error={isTypeError}>
                      <label>
                        {translate('modal.title.sbom_type')}
                      </label>
                      <Form.Dropdown
                        options={sbomTypeOptions}
                        selection
                        defaultValue={sbomType}
                        onChange={this.handleTypeChange}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('settings.list.precision')}</label>
                      <input
                        type="text"
                        value={this.setPrecisionLevel(precisionLevel)}
                        onChange={this.handlePrecisionLevelChange}
                        placeholder={translate('settings.list.precision')}
                        readOnly
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('modal.title.export_format')}</label>
                      <Form.Dropdown
                        options={exportFormatOptions}
                        selection
                        defaultValue={exportFormat}
                        onChange={this.handleExportFormatChange}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Field required error={isProductNameError}>
                    <label>{translate('modal.title.product_name')}</label>
                    <input
                      type="text"
                      value={productName}
                      onChange={this.handleProductNameChange}
                      placeholder={translate('modal.title.product_name')}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>{translate('modal.title.product_version')}</label>
                    <input
                      type="text"
                      value={productVersion}
                      onChange={this.handleProductVersionChange}
                      placeholder={translate('modal.title.product_version')}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>{translate('modal.title.sbom_author_name')}</label>
                    <input
                      type="text"
                      value={sbomAuthorName}
                      onChange={this.handleNameChange}
                      placeholder={translate('modal.title.sbom_author_name')}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>{translate('modal.title.file_export_to')}</label>
                    <Form.Dropdown
                      options={exportPathOptions}
                      selection
                      defaultValue={toExport}
                      onChange={this.handleExportPathChange}
                    />
                  </Form.Field>
                </Form>
              </Scrollbars>
              <div className="setting_popup_button_wrap">
                <a
                  className="button cencel_button"
                  onClick={this.closeModal}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  onClick={this.onSubmit}
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.ok')}
                </a>
              </div>
            </div>
          </div>
          <Modal open={isOpenAlertModal} onClose={this.closeAlertModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalAction}</h2>
                  {
                    toExport === 's3' ? (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        {this.modalHeader}
                        {this.modalSubBody}
                      </Modal.Description>
                    ) : (
                      <Modal.Description>
                        <Header>
                          {this.modalBody}
                        </Header>
                        <p className="modal_list">{this.modalHeader}</p>
                        <p>{this.modalSubBody}</p>
                      </Modal.Description>
                    )
                  }
                  {
                    isExportDoc ? (
                      <div className="button_wrap">
                        <a onClick={this.closeNISModal} className="center_button">
                          {translate('modal.button.ok')}
                        </a>
                      </div>
                    ) : (
                      <div className="button_wrap">
                        <a onClick={this.closeAlertModal} className="center_button">
                          {translate('modal.button.ok')}
                        </a>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </Modal>
          <Modal open={isOpenWarnModal} onClose={this.closeWarnModal}>
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalAction}</h2>
                  <p className="text">{this.modalBody}</p>
                  <div className="button_wrap">
                    <a onClick={this.closeWarnModal} className="left_button">
                      {translate('modal.button.cancel')}
                    </a>
                    {
                      isSaveSbom ? (
                        <a className="right_button" onClick={this.setNISInfo}>
                          {translate('modal.button.ok')}
                        </a>
                      ) : (
                        <a className="right_button" onClick={this.closeNISModal}>
                          {translate('modal.button.ok')}
                        </a>
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    };
    return (
      <Modal open={isOpenMNA} onClose={this.closeModal} className="create_spdx">
        {getModalContent()}
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(NISModal)));
